import { ApiService } from '@/services/api/ApiService';
import { VoiceFavorite } from '@/types/voice/favorites';
import { Voice } from '@/types/voice/voice';

export class VoiceFavoritesService {
  private static instance: VoiceFavoritesService;

  private constructor() {}

  public static getInstance(): VoiceFavoritesService {
    if (!VoiceFavoritesService.instance) {
      VoiceFavoritesService.instance = new VoiceFavoritesService();
    }
    return VoiceFavoritesService.instance;
  }

  /**
   * Add a voice to user's favorites
   */
  async addFavorite(voiceId: string, voiceData: Voice): Promise<VoiceFavorite | null> {
    try {
      const response = await ApiService.invoke({
        resource: "voices",
        action: "add-favorite",
        id: voiceId,
        data: {
          voice_data: voiceData,
        },
      });

      if (response?.already_favorited) {
        console.log("Voice already in favorites");
        return null;
      }

      return response?.favorite || null;
    } catch (error) {
      console.error("Failed to add favorite:", error);
      return null;
    }
  }

  /**
   * Remove a voice from user's favorites
   */
  async removeFavorite(voiceId: string): Promise<boolean> {
    try {
      const response = await ApiService.invoke({
        resource: "voices",
        action: "remove-favorite",
        id: voiceId,
      });

      return response?.success ?? false;
    } catch (error) {
      console.error("Failed to remove favorite:", error);
      return false;
    }
  }

  /**
   * Get all user's favorite voices
   */
  async getUserFavorites(): Promise<VoiceFavorite[]> {
    try {
      const response = await ApiService.invoke({
        resource: "voices",
        action: "favorites",
      });

      return response?.favorites || [];
    } catch (error) {
      console.error("Failed to fetch favorites:", error);
      return [];
    }
  }

}
